import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ptDynamicComponentPortal]',
})
export class DynamicComponentPortalDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
